import { render, staticRenderFns } from "./DelLevel.vue?vue&type=template&id=6e83dce4&scoped=true"
import script from "./DelLevel.vue?vue&type=script&lang=ts"
export * from "./DelLevel.vue?vue&type=script&lang=ts"
import style0 from "./DelLevel.vue?vue&type=style&index=0&id=6e83dce4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e83dce4",
  null
  
)

export default component.exports